import { Component, OnInit } from '@angular/core';
import { WindowLoaderService } from 'src/app/shared/components/window-loader/window-loader.service';
import { CreditCardPaymentInformation } from '../../models/healthSystemPaymentInformation';
import { PhysicianService } from '../../physician.service';

@Component({
  selector: 'app-setup-payment-method',
  templateUrl: './setup-payment-method.component.html',
  styleUrls: ['./setup-payment-method.component.scss']
})
export class SetupPaymentMethodComponent implements OnInit {

  initialized: boolean = false;

  creditCardPaymentInformation: CreditCardPaymentInformation;
  constructor(private physicianService: PhysicianService, private loaderService: WindowLoaderService) { }

  ngOnInit() {

    this.LoadCheckoutSummary();
  }
  private LoadCheckoutSummary() {
    this.loaderService.show();
    this.physicianService.getPaymentInformation().subscribe(
      (checkoutSummary) => {
        this.creditCardPaymentInformation = checkoutSummary;
        this.initialized = true;
        this.loaderService.hide();
      },
      (error) => { console.error(error); this.loaderService.hide(); },
      () => { this.loaderService.hide(); });
  }

  reload() {
    this.LoadCheckoutSummary();
  }

}
